// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"82332b14","498":"26de99d1","513":"fe187499"}[chunkId] + ".chunk.js";
};